export default {
  requestChangeAction: ({ partnerId }) => `partners/${partnerId}/update-requests`,
  partnerDetails: ({
    partnerId,
    isPartner,
  }) => {
    if (isPartner) return "users/profile"
    return `partners/${partnerId}`
  },
  agreementESignStatus: ({ partnerID }) => `partners/${partnerID}/agreement/status`,
  getEditRequests: ({ isPartner, partnerID }) => {
    if (isPartner) {
      return "partners/update-requests"
    }

    return `partners/${partnerID}/update-requests`
  },
  getFlags: ({ isPartner, partnerID }) => {
    if (isPartner) {
      return "partners/profile/flags"
    }

    return `partners/${partnerID}/flags`
  },
  basicInfo: ({ partnerID }) => `partners/${partnerID}/basic-info`,

}
